import { ref } from 'config/constants'
import * as messages from "data/messages/actions";

import {
  FETCH_USER,
  DELETE_USER,
  FETCH_USERS,
  UPDATE_SMSAUTH,
  USER_UPDATE,
  USER_UPDATE_SUCCESS,
  USER_UPDATE_FAILURE
} from './types';

const Users = ref.child("users");

/* USER */
export function updateUserInfo(user) {
  console.log(user);
  return dispatch => {
    dispatch({
      type: USER_UPDATE,
      payload: user
    })
    return dispatch => {
      Users.child(`${user.info.uid}/info`)
        .set(user.info)
        .then(() => {
          dispatch({
            type: USER_UPDATE_SUCCESS,
            payload: user
          })
        })
        .catch(error => {
          dispatch({
            type: USER_UPDATE_FAILURE,
            payload: error
          });
          dispatch(messages.showMessage(error.message));
        });
      }
  }
}

export function updateUser(uid, user) {
  return dispatch => Users.child(uid).set(user);
}


export function deleteUser(key) {
  return dispatch => {
    Users.child(key).remove()
      .then(() => {
        dispatch({
          type: DELETE_USER,
          payload: key
        })
      })
    }
}

export function fetchUser(uid) {
  return dispatch => {
    Users.child(uid).on('value', snapshot => {
      dispatch({
        type: FETCH_USER,
        payload: snapshot.val()
      });
    });
  };
}


export function fetchUsers() {
  return dispatch => {
    Users.on('value', snapshot => {
      dispatch({
        type: FETCH_USERS,
        payload: snapshot.val()
      });
    });
  };
};


export function smsauth(user, code) {
  console.log(user, code);

  return dispatch => {
    Users.child(`${user.uid}/activation/code`)
      .set(code)
      .then(() => {
        dispatch({
          type: UPDATE_SMSAUTH,
          payload: code
        })
      })
    }
}



// WEBPACK FOOTER //
// ./src/data/users/actions.js